export default __webpack_public_path__ + "static/media/31.194ac67f.jpg";